import { useCallback, useState } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import map from 'lodash/map';

import generateAlphaNumericId from 'src/presentation/components/pages/ivr/helpers/generateAlphaNumericId';

const useOptionsGeneratedIds = items => {
  const [optionsIds, setOptionsIds] = useState(map(items, () => generateAlphaNumericId()));

  const addOptionId = useCallback(() => {
    setOptionsIds([...optionsIds, generateAlphaNumericId()]);
  }, [setOptionsIds, optionsIds]);

  const removeOptionIdByIndex = useCallback(
    index => {
      const cloned = cloneDeep(optionsIds);
      cloned.splice(index, 1);
      setOptionsIds(cloned);
    },
    [setOptionsIds, optionsIds]
  );

  return { addOptionId, optionsIds, removeOptionIdByIndex };
};

export default useOptionsGeneratedIds;
